import script from "./SourcesModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SourcesModal.vue?vue&type=script&setup=true&lang=js"

import "./SourcesModal.vue?vue&type=style&index=0&id=1121dc82&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1121dc82"]])

export default __exports__